import { Box, Container, Flex, Button, Image } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import CourseStepNav from './CourseStepNav';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <Box minH="100vh" bg="gray.50">
      <Box bg="#1AC8ED" shadow="sm" mb={8}>
        <Container maxW="container.xl">
          <Flex justify="space-between" align="center" py={4}>
            <Image 
              src="/RL Logo.svg" 
              alt="Rad Learning Logo" 
              h="50px"
              w="auto"
              onClick={() => navigate('/s/landing')}
              cursor="pointer"
              _hover={{
                opacity: 0.9,
                transform: 'translateY(-1px)',
              }}
              transition="all 0.2s"
            />
            <Button 
              bg="#C200FB" // RL Purple
              color="white"
              _hover={{
                bg: '#A800D6', // Slightly darker purple on hover
                transform: 'translateY(-1px)',
                boxShadow: 'md',
              }}
              _active={{
                bg: '#17FFC4', // RL Green on click
                color: 'black',
                transform: 'translateY(0)',
              }}
              _focusVisible={{
                bg: '#17FFC4', // RL Green on focus
                color: 'black',
                boxShadow: '0 0 0 3px rgba(24, 144, 255, 0.5)',
              }}
              size="sm" 
              onClick={handleLogout}
              transition="all 0.2s"
            >
              Logout
            </Button>
          </Flex>
        </Container>
      </Box>
      <Container maxW="container.xl" py={8}>
        <CourseStepNav />
        {children}
      </Container>
    </Box>
  );
}
